import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import { SmsEditor } from "@autoserve/woosent.woosent.sms-editor";

interface Props {
	next: (value: string | string[]) => void;
	goBack: () => void;
	message: string;
	setMessage: React.Dispatch<React.SetStateAction<string>>;
	error: string;
	setError: React.Dispatch<React.SetStateAction<string>>;
	image: File | null;
	setImage: React.Dispatch<React.SetStateAction<File | null>>;
	setImageUri: React.Dispatch<React.SetStateAction<string>>;
	setS3Url: React.Dispatch<React.SetStateAction<string>>;
}

const Message = ({
	next,
	goBack,
	message,
	setMessage,
	error,
	setError,
	image,
	setImage,
	setImageUri,
	setS3Url,
}: Props) => {
	const handleChange = (event: { target: { value: string } }) => {
		if (Boolean(error.length)) {
			setError("");
		}
		setMessage(event.target.value);
	};

	const handleInsertImage = (file: File) => {
		if (file) {
			setImage(file);
		}
	};

	const handleDeleteImage = () => {
		setImage(null);
		setImageUri("");
		setS3Url("");
	};

	return (
		<Box sx={{ p: 1.5 }}>
			<SmsEditor
				error={Boolean(error.length)}
				errorText={error}
				setErrorText={setError}
				enableUrlShortener={false}
				enableInsertImage={true}
				sendable={false}
				fullWidth={true}
				value={message}
				handleInputChange={handleChange}
				handleAddEmoji={(emoji) => setMessage(message + emoji)}
				handleConcatInputValue={(concatVal) => setMessage(message + concatVal)}
				handleInsertImage={handleInsertImage}
				imageAttachment={image}
				handleDeleteImage={handleDeleteImage}
			/>
			<Box sx={{ mt: 2 }}>
				<Button
					variant='contained'
					sx={{ mt: 1, mr: 1 }}
					onClick={() => next(message)}>
					Next
				</Button>
				<Button sx={{ mt: 1, mr: 1 }} onClick={goBack}>
					Back
				</Button>
			</Box>
		</Box>
	);
};

export default Message;
